import doc             from '@widesk-core/decorators/doc';
import model           from '@widesk-core/decorators/model';
import MapServiceModel from '@/models/MapServiceModel';

@model.cacheDuration()
@model.urnResource('plan_detection_status')
@doc.path('/plan_detection_statuses/{?id}')
export default class PlanDetectionStatusModel extends MapServiceModel {
	@doc.string declare label: string;
	@doc.string declare reference: string;
}
